import React from 'react';
import { message } from 'antd';
import * as API from '../api';
import { Column } from './Flex';
import Spacer from './Spacer';
import store from '../store';
import { loadingDuck } from '../ducks/root';

class ContactForm extends React.Component {
  state = {
    email: '',
    name: '',
    message: '',
  };

  // getInitialProps = async () => {
  //   const { pracKey } = this.props;
  //   let msgParams = { pracKey: pracKey };
  //   console.log('checking if emails enabled');
  //   const resp = await API.post(['emailEnabled'], msgParams);

  //   return { enabled: resp.response.data };
  // };

  Inp = ({ label, placeholder, id, type }) => {
    let props = {
      key: 'inp',
      type: type || 'text',
      className: 'cstm',
      placeholder: placeholder || label || 'Type here',
      value: this.state[id] || '',
      onChange: evt => {
        this.setState({ [id]: evt.target.value });
      },
    };
    return [
      type === 'textarea' ? <textarea {...props} /> : <input {...props} />,
      <Spacer ky="sp" size="xsmall" />,
    ];
  };

  success = val => {
    message.success(val);
  };

  error = val => {
    message.error(val);
  };

  render() {
    // console.log(JSON.stringify(this.props, null, 2));
    // if (this.props.enabled === false) return null;
    const Inp = this.Inp;
    return (
      <form
        onSubmit={evt => {
          evt.preventDefault();
          store.dispatch(loadingDuck.set({ show: true, text: 'Sending...' }));
          // if (!this.props.to) {
          //   store.dispatch(loadingDuck.clear());
          //   this.error(
          //     'This DPC Frontier practice is not associated with an email address, so it cannot receive messages.'
          //   );
          //   return;
          // }
          if (!this.state.name || !this.state.message || !this.state.email) {
            this.error('Missing required field.');
            store.dispatch(loadingDuck.clear());
            return;
          }

          let msgParams = {
            pracKey: this.props.pracKey,
            from: this.state.email,
            subject: 'New message from ' + this.state.email,
            html: [
              "You've received a new message via your DPC Frontier profile page. Just hit Reply to respond to the sender.",
              '<br/>',
              `Name: ${this.state.name}`,
              `Email: ${this.state.email}`,
              `Message is below.`,
              '------------------------<br/>',
              this.state.message,
            ].join('<br/>'),
            replyto: this.state.email,
          };

          console.log('msgParams');
          console.log(JSON.stringify(msgParams, null, 2));
          API.post(['send'], msgParams)
            .then(resp => {
              console.log(resp);
              console.log('sent message');
              store.dispatch(loadingDuck.clear());
              this.success('Message sent!');

              setTimeout(() => {
                this.setState({
                  email: '',
                  name: '',
                  message: '',
                });
              }, 400);
            })
            .catch(err => {
              store.dispatch(loadingDuck.clear());
              if (!err.response) this.error('An unknown error occurred.');
              else this.error(err.response.data.message);
            });
        }}
      >
        <Column align="flex-start">
          <Inp label={'Your name'} id="name" />
          <Inp label={'Your email'} id="email" />
          <Inp type="textarea" label={'Your message'} id="message" />
          <input type="submit" className="cstm" />
        </Column>
      </form>
    );
  }
}

export default ContactForm;
